import type { ReactNode } from 'react';
import type { LoopTeamFilterKey } from '@/common/api/loopTeamTableFilters';
import type {
  BacklogItemFilterKey,
  DatetimeFilterKeys,
  ItemFilterKey,
  LocationFilterKey,
  PicklistFilterKeys,
  ResourceFilterKey,
  SkillFilterKey,
  StringFilterKeys,
  TeamFilterKey,
  TeamsFilterKey,
} from '@/common/api/types/itemFilters';
import {
  datetimeItemFilterSchema,
  picklistItemFilterSchema,
  stringItemFilterSchema,
} from '@/common/zod-schemas/itemFilterSearchSchema';

export const picklistItemFilterKeys = Object.keys(
  picklistItemFilterSchema.shape,
) as PicklistFilterKeys[];

export const datetimeItemFilterKeys = Object.keys(
  datetimeItemFilterSchema.shape,
) as DatetimeFilterKeys[];

export const stringItemFilterKeys = Object.keys(stringItemFilterSchema.shape) as StringFilterKeys[];

export type FilterOption = {
  label: string;
  value: string | number;
  icon?: ReactNode;
  component?: ReactNode;
};

export type CustomFieldFilterKey = `cf.${number}.${string}`;

export type FilterKey =
  | ItemFilterKey
  | BacklogItemFilterKey
  | LocationFilterKey
  | ResourceFilterKey
  | TeamFilterKey
  | TeamsFilterKey
  | LoopTeamFilterKey
  | SkillFilterKey
  | CustomFieldFilterKey;

export interface ItemFilterConfig<TFilterKey extends FilterKey = FilterKey> {
  key: TFilterKey;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
  disabledTooltip?: string;
  currencyUnit?: string | null;
}

export type ItemFilterConfigMap<TFilterKey extends FilterKey = FilterKey> = Partial<
  Record<TFilterKey, ItemFilterConfig<TFilterKey>>
>;
